import { CnOSSUpload } from '@cainiaofe/cn-ui';
export function UploadCom(props) {
    const { mode, ...rest } = props;
    // let Component = CnOSSUpload;
    // if(mode === 'oss') {
    //   Component = CnOssUpload;
    // }
    return <CnOSSUpload {...rest}/>;
}
